module.exports = __webpack_public_path__ + "static/media/mail.91837fdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/mail.svg
// module id = 291
// module chunks = 0